import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd } from "@/lib/seo";
import { FAQS_APP_DEVELOPMENT } from "@/lib/service-content/faqs/app-development";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/desarrollo-apps-shopify";

export const Route = createFileRoute("/es/desarrollo-apps-shopify")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Desarrollo de Apps Shopify: Públicas, Custom y Embebidas · Shugert",
    description: "Apps Shopify con límite de producto, extensiones soportadas, seguridad, billing, observabilidad y operación de launch. Proyectos desde $6,000 USD.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-app-development-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Servicios", path: "/es/servicios" }, { name: "Desarrollo de Apps Shopify", path: PATH }]),
      faqJsonLd(FAQS_APP_DEVELOPMENT.es),
      serviceJsonLd({
        name: "Desarrollo de Apps Shopify",
        description: "Aplicaciones Shopify públicas, custom y embebidas con superficies soportadas, seguridad, billing, observabilidad y modelo operativo definido.",
        path: PATH,
        serviceType: "Desarrollo de Apps Shopify",
        minPrice: 6000,
        unit: "PROJECT",
        deliverables: ["Límite de producto y permisos", "Arquitectura de plataforma", "Diseño operativo y de seguridad", "App en staging", "Paquete de launch o submission"],
        locale: "es",
      }),
    ],
  }),
});
